import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container__tooltip"
}

import IconSmallInfo from '../assets/icons/IconSmallInfo.vue'
import TooltipStandardV2 from '../atoms/TooltipStandardV2.vue'
import { onMounted, onUnmounted, ref } from 'vue'

type Props = {
  title?: string
  info?: string
  size?: 'medium' | 'mediumBold'
  fullscreen?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoLabel',
  props: {
    title: {},
    info: {},
    size: {},
    fullscreen: { type: Boolean }
  },
  setup(__props: any) {



const isVisible = ref(false)

function presentInfo(e: MouseEvent) {
  e.stopPropagation()
  isVisible.value = isVisible.value ? false : true
}

function dismissInfo() {
  isVisible.value = false
}
/** Lifecycle hooks */
onMounted(() => document.addEventListener('click', dismissInfo))
onUnmounted(() => document.removeEventListener('click', dismissInfo))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    onClick: presentInfo
  }, [
    _createElementVNode("span", {
      class: _normalizeClass({
        container__label__medium_and_bold: _ctx.size === 'mediumBold',
        container__label__medium: _ctx.size === 'medium'
      })
    }, _toDisplayString(_ctx.title), 3),
    (_ctx.info)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(TooltipStandardV2, {
            style: 'margin-top: 5px; margin-left: 4px;',
            text: _ctx.info,
            arrowPosition: !_ctx.fullscreen ? 'top-center' : 'center-right',
            verticalOffset: !_ctx.fullscreen ? 4 : 1,
            horizontalOffset: !_ctx.fullscreen ? 0 : 2
          }, {
            default: _withCtx(() => [
              _createVNode(IconSmallInfo, { class: "container__tooltip__icon" })
            ]),
            _: 1
          }, 8, ["text", "arrowPosition", "verticalOffset", "horizontalOffset"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})